import { imageContainsURL } from '@/react/docker/images/utils';

// Docker treats the first path component as a registry host when it contains
// "." or ":" or is exactly "localhost".
export function imageHasRegistryHost(image: string): boolean {
  const reference = image.trim();
  return imageContainsURL(reference) || reference.startsWith('localhost/');
}
